<template>
  <div>
    <!-- 查询表单 -->
    <el-form
    ref="search_form"
    :model="search_form"
    label-width="80px"
    class="search_form"
    >
      <el-form-item label="发车日期" prop="new_date">
        <el-date-picker
        style="width: 100%;"
        v-model="search_form.new_date"
        type="daterange"
        align="right"
        unlink-panels
        range-separator='截止'
        value-format="yyyy-MM-dd"
        @change="new_date_change"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="始发地" prop="origin">
        <el-input v-model="search_form.origin"></el-input>
      </el-form-item>
      <el-form-item label="目的地" prop="destination">
        <el-input v-model="search_form.destination"></el-input>
      </el-form-item>
      <el-form-item label="承运商" prop="carrier">
        <el-input v-model="search_form.carrier"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
        type="primary"
        icon="el-icon-search"
        @click="search_province"
        v-if="btn_permission.includes('middle:expenses:nonLocalList')||btn_permission.includes('superAdmin')"
        >查询</el-button>
        <el-button
        icon="el-icon-close"
        @click="reset_province"
        v-if="btn_permission.includes('middle:expenses:nonLocalList')||btn_permission.includes('superAdmin')"
        >清除</el-button>
      </el-form-item>
    </el-form>
    <div style="margin: 10px 0;">
      <el-button
      type="primary"
      icon="el-icon-plus"
      @click="add_province"
      v-if="btn_permission.includes('middle:expenses:addNonLocal')||btn_permission.includes('superAdmin')"
      >录入</el-button>
      <el-button
      type="primary"
      icon="el-icon-download"
      @click="export_data"
      v-if="btn_permission.includes('middle:expenses:exportNonLocal')||btn_permission.includes('superAdmin')"
      >导出</el-button>
      <el-button
      type="warning"
      icon="el-icon-present"
      @click="get_amount"
      v-if="btn_permission.includes('middle:expenses:nonLocalAmount')||btn_permission.includes('superAdmin')"
      >费用总计</el-button>
      <el-button
      type="warning"
      icon="el-icon-present"
      @click="check_amount"
      >选中费用总计</el-button>
    </div>
    <!-- 新增外地费用弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="addVisible"
    :title="add_edit_title"
    >
      <el-form
      ref="add_form"
      :model="add_form"
      label-width="100px"
      class="add_form"
      :rules="add_rules"
      :disabled="add_form_status"
      >
        <el-form-item class="other_form" label="发车日期" prop="add_date">
          <el-date-picker
          style="width: 100%;"
          v-model="add_form.add_date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator='到货日期'
          value-format="yyyy-MM-dd"
          @change="add_date_change"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="始发地" prop="origin">
          <el-input v-model="add_form.origin"></el-input>
        </el-form-item>
        <el-form-item label="目的地" prop="destination">
          <el-input v-model="add_form.destination"></el-input>
        </el-form-item>
        <el-form-item label="要求温度" prop="reqTemp">
          <el-input v-model="add_form.reqTemp"></el-input>
        </el-form-item>
        <el-form-item label="到货温度" prop="arrTemp">
          <el-input v-model="add_form.arrTemp"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="payType">
          <el-select
          style="width: 100%;"
          :popper-append-to-body="false"
          v-model="add_form.payType"
          clearable
          >
            <el-option label="月结" value="monthPay"></el-option>
            <el-option label="日结" value="dayPay"></el-option>
            <el-option label="其他" value="otherPay"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单价" prop="price">
          <el-input v-model="add_form.price"></el-input>
        </el-form-item>
        <el-form-item label="发运次数" prop="sendNum">
          <el-input type="number" v-model="add_form.sendNum"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input :disabled="true" v-model="add_form.amount"></el-input>
        </el-form-item>
        <el-form-item label="仪器名称" prop="instrument">
          <el-input v-model="add_form.instrument"></el-input>
        </el-form-item>
        <el-form-item label="车型" prop="model">
          <el-input v-model="add_form.model"></el-input>
        </el-form-item>
        <el-form-item label="体积(m³)" prop="volume">
          <el-input v-model="add_form.volume"></el-input>
        </el-form-item>
        <el-form-item label="重量(KG)" prop="weight">
          <el-input v-model="add_form.weight"></el-input>
        </el-form-item>
        <el-form-item label="承运商" prop="carrier">
          <el-input v-model="add_form.carrier"></el-input>
        </el-form-item>
        <el-form-item label="保险费" prop="insurancePremium">
          <el-input v-model="add_form.insurancePremium"></el-input>
        </el-form-item>
        <el-form-item label="费率(%)" prop="rate">
          <el-input v-model="add_form.rate"></el-input>
        </el-form-item>
        <el-form-item class="other_form" label="备注" prop="carriageDesc">
          <el-input type="textarea" v-model="add_form.carriageDesc"></el-input>
        </el-form-item>
        <el-form-item class="other_form">
          <el-button
          type="primary"
          icon="el-icon-circle-check"
          @click="save_province"
          >保存</el-button>
          <el-button
          icon="el-icon-circle-close"
          @click="cancel_province"
          >关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 外地费用列表 -->
    <el-table
    :data="list_data"
    highlight-current-row
    border
    show-summary
    max-height="400"
    :summary-method="getSummaries"
    @selection-change="change_rows"
    >
      <el-table-column
      align="center"
      fixed="left"
      type="selection"
      width="80px"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      sortable
      prop="sendDate"
      label="发车日期"
      width="160px"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="arrDate"
      label="到货日期"
      width="160px"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="origin"
      label="始发地"
      show-overflow-tooltip
      ></el-table-column>
      <el-table-column
      align="center"
      prop="destination"
      label="目的地"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="carrier"
      label="承运商"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="reqTemp"
      label="要求温度"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="arrTemp"
      label="到货温度"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="instrument"
      label="仪器名称"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="price"
      label="单价"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="sendNum"
      label="发运次数"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="insurancePremium"
      label="保险费"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="rate"
      label="费率"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="amount"
      label="金额"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="createName"
      label="创建人"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="createDate"
      width="160px"
      label="创建日期"
      ></el-table-column>
      <el-table-column
      align="center"
      prop="updateName"
      label="修改人"
      ></el-table-column>
      <el-table-column
      show-overflow-tooltip
      align="center"
      prop="updateDate"
      label="修改日期"
      ></el-table-column>
      <el-table-column width="200px" align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-tag
          class="operate"
          type="success"
          effect="dark"
          @click="check_detail(scope.row)"
          v-if="btn_permission.includes('middle:expenses:nonLocalById')||btn_permission.includes('superAdmin')"
          >查看明细</el-tag>
          <el-tag
          class="operate"
          type="warning"
          effect="dark"
          @click="edit_province(scope.row)"
          v-if="btn_permission.includes('middle:expenses:editNonLocal')||btn_permission.includes('superAdmin')"
          >修改</el-tag>
          <el-tag
          class="operate"
          type="danger"
          effect="dark"
          @click="delete_province(scope.row)"
          v-if="btn_permission.includes('middle:expenses:delNonLocal')||btn_permission.includes('superAdmin')"
          >删除</el-tag>
        </template>
      </el-table-column>
    </el-table>
   <!-- 外地费用列表分页 -->
   <el-pagination
   style="margin: 10px auto;"
   background
   @size-change="province_size_change"
   @current-change="province_current_change"
   :current-page="province_current_page"
   :page-sizes="[10,15,20,25]"
   :page-size="province_page_size"
   layout="total, sizes, prev, pager, next, jumper"
   :total="province_total"
   ></el-pagination>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //查询表单
        search_form:{
          new_date:'',
          startDate:'',
          endDate:'',
          origin:'',
          destination:'',
          carrier:''
        },
        //新增弹框标题
        add_edit_title:'',
        //新增或修改
        add_edit:'',
        //当前行
        now_row:{},
        //新增外地费用弹框
        addVisible:false,
        add_rules:{
          add_date:[
            {required:true,message:'请选择发车/到货日期',trigger:'change'}
          ],
          origin:[
            {required:true,message:'请输入始发地',trigger:'blur'}
          ],
          destination:[
            {required:true,message:'请输入目的地',trigger:'blur'}
          ],
          reqTemp:[
            {required:true,message:'请输入要求温度',trigger:'blur'}
          ],
          arrTemp:[
            {required:true,message:'请输入到货温度',trigger:'blur'}
          ],
          payType:[
            {required:true,message:'请选择结算方式',trigger:'change'}
          ],
          price:[
            {required:true,message:'请输入单价',trigger:'blur'}
          ],
          sendNum:[
            {required:true,message:'请输入发运次数',trigger:'blur'}
          ],
          instrument:[
            {required:true,message:'请输入仪器名称',trigger:'blur'}
          ],
          carrier:[
            {required:true,message:'请输入承运商',trigger:'blur'}
          ]
        },
        add_form:{
          add_date:'',
          sendDate:'',
          arrDate:'',
          origin:'',
          destination:'',
          reqTemp:'',
          arrTemp:'',
          payType:'',
          price:'',
          sendNum:'',
          amount:'',
          instrument:'',
          model:'',
          volume:'',
          weight:'',
          carrier:'',
          carriageDesc:'',
          insurancePremium:'',
          rate:''
        },
        //新增本地费用表单禁用状态
        add_form_status:false,
        //外地费用列表
        list_data:[],
        //外地费用列表分页
        province_current_page:1,
        province_page_size:10,
        province_total:0,
        //选中费用总计
        total_check:0
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //获取外地费用列表
      that.get_province()
    },
    mounted() {

    },
    methods:{
      //查询表单时间范围change事件
      new_date_change(value){
        if(value!=null){
          this.search_form.startDate=value[0]
          this.search_form.endDate=value[1]
        }else{
          this.search_form.startDate=''
          this.search_form.endDate=''
        }
      },
      //新增表单时间范围change事件
      add_date_change(value){
        if(value!=null){
          this.add_form.sendDate=value[0]
          this.add_form.arrDate=value[1]
        }else{
          this.add_form.sendDate=''
          this.add_form.arrDate=''
        }
      },
      //获取外地费用列表
      get_province(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/expenses/nonLocal/list',
          params:{
            page:that.province_current_page,
            limit:that.province_page_size,
            startDate:that.search_form.startDate,
            endDate:that.search_form.endDate,
            origin:that.search_form.origin,
            destination:that.search_form.destination,
            carrier:that.search_form.carrier
          }
        }).then(data=>{
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.province_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //指定列合计
      getSummaries(param){
        const { columns, data } = param
        const sums = []
        columns.forEach((column,index)=>{
          if(index==0){
            sums[index]='合计'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if(column.property=='amount'){
            sums[index]=values.reduce((prev,curr)=>{
              const value=Number(curr)
              if(!isNaN(value)){
                return prev+curr
              }else{
                return prev
              }
            },0).toFixed(2)
          }

        })
        return sums
      },
      //查询表单
      search_province(){
        this.province_current_page=1
        this.province_page_size=10
        //获取外地费用列表
        this.get_province()
      },
      //重置查询表单
      reset_province(){
        this.$refs.search_form.resetFields()
        this.search_form.startDate=''
        this.search_form.endDate=''
        this.province_current_page=1
        this.province_page_size=10
        //获取外地费用列表
        this.get_province()
      },
      //外地费用列表分页
      province_size_change(val){
        this.province_page_size=val
        //获取外地费用列表
        this.get_province()
      },
      province_current_change(val){
        this.province_current_page=val
        //获取外地费用列表
        this.get_province()
      },
      //新增外地费用前置
      add_province(){
        this.addVisible=true
        this.add_form_status=false
        this.add_edit='add'
        this.add_edit_title='新增外地费用'
        if(this.$refs.add_form!=undefined){
          this.$refs.add_form.resetFields()
        }
        this.add_form.origin=''
        this.add_form.destination=''
        this.add_form.reqTemp=''
        this.add_form.arrTemp=''
        this.add_form.payType=''
        this.add_form.price=''
        this.add_form.sendNum=''
        this.add_form.amount=''
        this.add_form.instrument=''
        this.add_form.model=''
        this.add_form.volume=''
        this.add_form.weight=''
        this.add_form.carrier=''
        this.add_form.carriageDesc=''
        this.add_form.insurancePremium=''
        this.add_form.rate=''
      },
      //修改外地费用前置
      edit_province(row){
        this.addVisible=true
        this.add_form_status=false
        this.add_edit='edit'
        this.add_edit_title='修改外地费用'
        this.now_row=row
        this.$set(this.add_form,"add_date",[
          row.sendDate,row.arrDate
        ])
        this.add_form.origin=row.origin
        this.add_form.destination=row.destination
        this.add_form.reqTemp=row.reqTemp
        this.add_form.arrTemp=row.arrTemp
        this.add_form.payType=row.payType
        this.add_form.price=row.price
        this.add_form.sendNum=row.sendNum
        this.add_form.amount=row.amount
        this.add_form.instrument=row.instrument
        this.add_form.model=row.model
        this.add_form.volume=row.volume
        this.add_form.weight=row.weight
        this.add_form.carrier=row.carrier
        this.add_form.carriageDesc=row.carriageDesc
        this.add_form.insurancePremium=row.insurancePremium
        this.add_form.rate=row.rate
      },
      //新增或修改外地费用保存
      save_province(){
        let that=this
        that.$refs.add_form.validate((valid)=>{
          if(valid){
            if(that.add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/expenses/nonLocal',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  sendDate:that.add_form.sendDate,
                  arrDate:that.add_form.arrDate,
                  origin:that.add_form.origin,
                  destination:that.add_form.destination,
                  reqTemp:that.add_form.reqTemp,
                  arrTemp:that.add_form.arrTemp,
                  payType:that.add_form.payType,
                  price:that.add_form.price,
                  amount:that.add_form.amount,
                  instrument:that.add_form.instrument,
                  model:that.add_form.model,
                  volume:that.add_form.volume,
                  weight:that.add_form.weight,
                  carrier:that.add_form.carrier,
                  carriageDesc:that.add_form.carriageDesc,
                  insurancePremium:that.add_form.insurancePremium,
                  rate:that.add_form.rate,
                  sendNum:that.add_form.sendNum
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.addVisible=false
                  //获取外地费用列表
                  that.get_province()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/expenses/nonLocal/'+that.now_row.id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  sendDate:that.add_form.sendDate,
                  arrDate:that.add_form.arrDate,
                  origin:that.add_form.origin,
                  destination:that.add_form.destination,
                  reqTemp:that.add_form.reqTemp,
                  arrTemp:that.add_form.arrTemp,
                  payType:that.add_form.payType,
                  price:that.add_form.price,
                  amount:that.add_form.amount,
                  instrument:that.add_form.instrument,
                  model:that.add_form.model,
                  volume:that.add_form.volume,
                  weight:that.add_form.weight,
                  carrier:that.add_form.carrier,
                  carriageDesc:that.add_form.carriageDesc,
                  insurancePremium:that.add_form.insurancePremium,
                  rate:that.add_form.rate,
                  sendNum:that.add_form.sendNum
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.addVisible=false
                  //获取外地费用列表
                  that.get_province()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //取消
      cancel_province(){
        this.addVisible=false
      },
      //删除外地费用
      delete_province(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/expenses/nonLocal/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              //获取外地费用列表
              that.get_province()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //查看明细
      check_detail(row){
        this.addVisible=true
        this.add_form_status=true
        this.add_edit_title='查看外地费用详情'
        this.$set(this.add_form,"add_date",[
          row.sendDate,row.arrDate
        ])
        this.add_form.origin=row.origin
        this.add_form.destination=row.destination
        this.add_form.reqTemp=row.reqTemp
        this.add_form.arrTemp=row.arrTemp
        this.add_form.payType=row.payType
        this.add_form.price=row.price
        this.add_form.sendNum=row.sendNum
        this.add_form.amount=row.amount
        this.add_form.instrument=row.instrument
        this.add_form.model=row.model
        this.add_form.volume=row.volume
        this.add_form.weight=row.weight
        this.add_form.carrier=row.carrier
        this.add_form.carriageDesc=row.carriageDesc
        this.add_form.insurancePremium=row.insurancePremium
        this.add_form.rate=row.rate
      },
      //费用总计
      get_amount(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/expenses/nonLocal/totalFee'
        }).then(data=>{
          if(data.data.success==true){
            that.$message.closeAll()
            that.$message({
              type:'success',
              message:'费用总计：'+data.data.data,
              duration:0,
              showClose: true,
            })
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //选中费用总计前置
      change_rows(rows){
        let that=this
        that.total_check=0
        rows.forEach((item,index)=>{
          that.total_check+=item.amount
        })
      },
      //选中费用总计
      check_amount(){
        let that=this
        that.$message.closeAll()
        that.$message({
          type:'success',
          message:'选中费用总计：'+that.total_check.toFixed(2),
          duration:0,
          showClose: true,
        })
      },
      //导出外地费用
      export_data(){
        const loading=this.$loading({
          lock:true,
          text:'正在拼命导出，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        let that=this
        let url='/middle/expenses/nonLocal/export?startDate='+that.search_form.startDate+'&endDate='+that.search_form.endDate
        +'&origin='+that.search_form.origin+'&destination='+that.search_form.destination+'&carrier='+that.search_form.carrier
        let xmlResquest=new XMLHttpRequest()
        xmlResquest.open('GET',this.publicAjax.extra_path+url,true)
        //设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json")
        xmlResquest.setRequestHeader("scctoken",localStorage.getItem(localStorage.getItem('userName')+'token'))
        xmlResquest.responseType="blob"
        xmlResquest.onreadystatechange=function(){
          if(xmlResquest.status===200){
            if(xmlResquest.readyState===4){
              var content=xmlResquest.response
              if(content.size==104){
                that.$message.warning('暂未授权，无权操作,请联系管理员！')
              }else{
                var elink=document.createElement('a')
                elink.download="外地费用.xls"
                elink.style.display='none'
                var blob=new Blob([content])
                elink.href=URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
                loading.close()
              }
            }
          }else{
            loading.close()
          }
        }
        xmlResquest.send()
        return false
      }
    }
  }
</script>

<style scoped="scoped">
  .search_form .el-form-item,
  .add_form .el-form-item{
    width: 33%;
    display: inline-block;
  }
  .add_form .other_form{
    width: 100%;
  }
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
</style>
<style>
  .el-range-separator{
    width: 40% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/expense/province.vue